import {Input, LabelText, SpanText, Text} from "../../../design";
import React, { useState, useEffect } from "react";
import { Radio } from 'antd';
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { inputHeight, normalTextFontSize, smallTextFontSize } from "../../../utils/reseponsive";

type Props = {
  label: string,
  description: string,
  control: any,
  errors: any,
  isRequired: boolean,
  name: string,
  isPreview: boolean,
  isAdaptive: boolean,
  selectedAccount: Object,
  data: Object,
  callMember: Function,
}

const InputAlphaNumeric = (props: Props) => {
  const { label, description, control, errors, name, isRequired, isPreview, isAdaptive, selectedAccount, data, callMember } = props;
  const { gid } = selectedAccount;

  const [value, setValue] = useState(1);

  const accntGid = [
    "account-441a1ebbae8a4e3d95abda2e86ccf7d6"
  ];

  useEffect(() => {
    if (accntGid.includes(gid)) {
      data.Key = 1;
      data.DisplayName = 'Yes';
      data.Value = 'Yes';
      data.acceptText = true;
      callMember(data)
    }
  }, []);

  const updateGroup = (e) => {
    setValue(e.target.value);
    if (e.target.value === 1) {
      data.Key = 1;
      data.DisplayName = 'Yes';
      data.Value = 'Yes';
      data.acceptText = true;
    } else if (e.target.value === 2) {
      data.Key = 2;
      data.DisplayName = 'No';
      data.Value = 'No';
      data.acceptText = true;
    }
    callMember(data);
  };

  const OnInput = event => {
    event.target.value = event.target.value.replace(/[^A-Za-z0-9 ]/g, '')
  };
  return (
    <>
      <div className="form-group row mb-0 no-gutters align-items-center">
        <div className="col-sm-5">
          <LabelText fontSize={normalTextFontSize(isPreview, isAdaptive)} color="#0000000"
                     hidden={!label} htmlFor="alpha" className="col-form-label font-weight-bolder m-0 text-break">{label}
            {/* <SpanText className="pl-2" hidden={isRequired} color="rgba(0, 0, 0, 0.6)"
                      fontSize={smallTextFontSize(isPreview, isAdaptive)}>(Optional)</SpanText> */}
                      </LabelText>
        </div>
        {
          accntGid.includes(gid) ? (
            <div className="col-sm-7">
              <Radio.Group value={value} onChange={updateGroup}>
                  <Radio className="col-form-label font-weight-bolder m-0 text-break" value={1}>&nbsp;Yes</Radio><br />
                  <Radio className="col-form-label font-weight-bolder m-0 text-break" value={2}>&nbsp;No</Radio>
                  <div><a href="https://www.tvksangha.org/renew_membership.php" target="_blank"> https://www.tvksangha.org/renew_membership.php</a></div>
              </Radio.Group>
            </div>
          ) : (
            <div className="col-sm-7">
          <Controller
            defaultValue={''}
            border="1px solid #29B1CC !important"
            control={control}
            name={name}
            rules={{
              required: isRequired && "This field is required"
            }}
            as={<Input onInput={OnInput} maxLength={254} type="text" width="100%" fontSize={smallTextFontSize(isPreview, isAdaptive)} height={inputHeight(42, isPreview, isAdaptive)} className="bg-white" />}
          />
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => (
              <Text fontSize={smallTextFontSize(isPreview, isAdaptive)} marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
            )}
          />
        </div>
          )
          }
        
      </div>
      <div hidden={!description} className="col-sm-10 px-0">
        <LabelText className="text-mute mt-1" fontSize={smallTextFontSize(isPreview, isAdaptive)}>{description}</LabelText>
      </div>
    </>
  )
};

export default InputAlphaNumeric
